// React
import PropTypes from "prop-types";

// @mui material components
import { Card, Fade, Grid, Icon, InputLabel, Modal, Tooltip } from "@mui/material";

// Custom UI components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { useEffect, useRef, useState } from "react";
import { formatDateARG } from "utils/formatters";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "70%", xxl: "60%" },
  overflow: "visible",
};

export default function ModalDetalles({ open, handleClose, item }) {

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox pb={3}>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3} pb={0}>
              <SoftBox>
                <SoftTypography variant="h6">Detalles del pedido</SoftTypography>
              </SoftBox>
              <SoftBox>
                <Tooltip title="Cerrar" placement="top">
                  <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                    close
                  </Icon>
                </Tooltip>
              </SoftBox>
            </SoftBox>
            <SoftBox px={3}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Card>
                    <SoftBox p={2} display="flex" flexDirection="column" alignItems="center">
                      <>
                        <SoftTypography variant="h4">👤</SoftTypography>
                        <SoftTypography variant="caption">Cliente</SoftTypography>
                        <SoftTypography variant="caption" fontWeight="bold">
                          {`${item?.cliente?.nombre ?? "Particular"} ${
                            item?.cliente?.apellido ?? ""
                          }`}
                        </SoftTypography>
                      </>
                    </SoftBox>
                  </Card>
                </Grid>
                <Grid item xs={4}>
                  <Card>
                    <SoftBox p={2} display="flex" flexDirection="column" alignItems="center">
                      <>
                        <SoftTypography variant="h4">🗒️</SoftTypography>
                        <SoftTypography variant="caption">Estado</SoftTypography>
                        <SoftTypography variant="caption" fontWeight="bold">
                          {item?.estado}
                        </SoftTypography>
                      </>
                    </SoftBox>
                  </Card>
                </Grid>
                <Grid item xs={4}>
                  <Card>
                    <SoftBox p={2} display="flex" flexDirection="column" alignItems="center">
                      <>
                        <SoftTypography variant="h4">📅</SoftTypography>
                        <SoftTypography variant="caption">Fecha</SoftTypography>
                        <SoftTypography variant="caption" fontWeight="bold">
                          {item?.fechaPedido ? formatDateARG(item?.fechaPedido) : "Sin fecha"}
                        </SoftTypography>
                      </>
                    </SoftBox>
                  </Card>
                </Grid>
                {item?.detalles?.map((detalle, index) => (
                  <Grid item xs={12} key={index}>
                    <Card>
                      <SoftBox p={2} display="flex" flexDirection="row" alignItems="center">
                        <SoftTypography variant="h1">🍽️</SoftTypography>
                        <SoftBox p={2} display="flex" flexDirection="column">
                          <SoftTypography variant="h6" color="primary" fontWeight="bold">
                            {detalle?.producto?.nombre}
                          </SoftTypography>
                          <SoftTypography variant="caption" fontWeight="bold">
                            Cantidad: {detalle?.cantidad}
                          </SoftTypography>
                          <SoftTypography variant="caption" fontWeight="bold">
                            Precio unitario: ${detalle?.precio}
                          </SoftTypography>
                          {detalle?.comentario && (
                            <SoftBox ml="auto" display="flex" flexDirection="column">
                              <SoftTypography variant="caption" fontWeight="bold">
                                Comentario: {detalle?.comentario}
                              </SoftTypography>
                            </SoftBox>
                          )}
                        </SoftBox>
                      </SoftBox>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalDetalles.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};
